<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main-fluid";
import ChamadoLista from "@components/ChamadoLista";

export default {
  page: {
    title: "Chamados",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  components: {
    Layout,
    ChamadoLista
  },
  data: function() {
    return {
      showCadastroChamado: false,
      showTimeLine: false,
      title: "Chamados",
      items: [
        {
          text: "Página inicial",
          href: "/"
        },
        {
          text: "Chamados",
          href: "/Chamado",
          active: true
        }
      ],
      SelectedChamadoId: 0,
      totalizador: {}
    };
  },
  methods: {
    showModalChamado: function() {
      this.showTimeLine = !this.showTimeLine;
    },
    openModalChamado: function(id) {
      this.selectedChamadoId = id;
      this.showCadastroChamado = true;
    }
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <div class="card">
        <div class="card-body">
          <ChamadoLista :openModalChamado="openModalChamado" />
        </div>
      </div>
    </div>
  </Layout>
</template>
